import { render } from "./roadMonitor.vue?vue&type=template&id=54c38b4e&scoped=true"
import script from "./roadMonitor.vue?vue&type=script&lang=js"
export * from "./roadMonitor.vue?vue&type=script&lang=js"

import "./roadMonitor.vue?vue&type=style&index=0&id=54c38b4e&lang=scss&scoped=scoped"
import "./roadMonitor.vue?vue&type=style&index=1&id=54c38b4e&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c38b4e"]])

export default __exports__